import types from "../types"

const initial = {}

export const wishlist_reducer = (state = initial, { type, payload }) => {
	switch (type) {
		case types.WISHLIST:
			return payload ? {
				...payload, total_price: (payload.items.reduce((acc, curr) => {
					acc += curr.product.product_price * curr.quantity
					return acc;
				}, 0)).toFixed(2)
			} : state
		case types.WISHLIST_RESET:
			return initial
		case types.AUTH_RESET:
			return initial
		default:
			return state
	}
}